<div class="container-fluid">
  <div class="form-horizontal">
    <div class="flex row-collapse space-between mb-10">
      <div class="w-50">
        <h3>
          {{ 'events.registration.management.tab-title' | translate | titlecase }}
          <span>
            <a href="https://support.weblinkinternational.com/hc/en-us/articles/115002325268" target="_blank"
              ><img
                src="/assets/img/help.png"
                title="{{ 'events.registration.management.tab-title-help' | translate }}"
                class="wc-help-icon"
            /></a>
          </span>
          <span class="wl-event-reg-refresh-link">
            <a href="#" (click)="$event.preventDefault(); resetAndSearch()">
              {{ 'common.refresh' | translate | titlecase }}
            </a>
          </span>
        </h3>
      </div>
      <div class="w-50 text-right text-left-xs">
        {{ unfilteredRegistrationSearchResult.TotalCount }}
        {{ 'events.registration.management.total-count-label' | translate | titlecase }}
        (<a href="#" (click)="$event.preventDefault(); handleAttendeesWithNoProfileIdClick()"
          >{{ unfilteredRegistrationSearchResult.RegistrationsWithoutProfileCount }}
          {{ 'events.registration.management.total-without-profileid-count-label' | translate }}</a
        >)
      </div>
    </div>

    <div class="flex row-collapse space-between mb-10">
      <div class="w-50">
        <div class="input-group">
          <input type="text" class="form-control" [(ngModel)]="searchParams.Keyword" wl-on-enter-press (onEnterPess)="search()" />
          <span class="input-group-btn">
            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-default atlas-search"
              [icon]="isSearching ? '' : 'pi pi-search'"
              (click)="search()"
              [disabled]="isSearching"
            >
              <wl-busy [show]="isSearching"></wl-busy>
            </button>

            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-default atlas-search-clear"
              icon="pi pi-times-circle"
              (click)="resetAndSearch()"
              [disabled]="isSearching"
            ></button>
          </span>
        </div>
      </div>

      <div class="w-50">
        <select class="form-control" [(ngModel)]="searchParams.OrderBy" (ngModelChange)="getRegistrations()">
          <option value="">--{{ 'common.sort-by' | translate | titlecase }}--</option>
          @for (sortBy of sortByFields; track sortBy.value) {
            <option [value]="sortBy.value" [selected]="sortBy.value == searchParams.OrderBy ? true : null">
              {{ 'common.sort-by' | translate | titlecase }}: {{ sortBy.name }}
            </option>
          }
        </select>
      </div>
    </div>

    <div class="flex row-collapse space-between mb-10">
      <div class="w-100">
        <button
          pButton
          type="button"
          class="btn btn-sm btn-default"
          [ngClass]="{ 'wl-event-reg-open-close-open': showAdvancedSearch }"
          (click)="toggleAdvancedSearch()"
        >
          <span class="wl-event-reg-open-close-icon glyphicon glyphicon-chevron-down"></span>
        </button>
        {{ 'common.advancedSearch' | translate | titlecase }}
      </div>
    </div>

    @if (showAdvancedSearch) {
      <div>
        <div class="form-group">
          <div class="col-sm-12">
            <p>{{ 'events.registration.management.sign-up-date-label' | translate | titlecase }}</p>

            <span class="wl-give-calendar-right-padding date-selector-container">
              <wl-date-selector [(ngModel)]="searchParams.SignUpStartDate" [disabled]="searchParams.SearchAnySignUpDate"></wl-date-selector>
              <wl-date-selector [(ngModel)]="searchParams.SignUpEndDate" [disabled]="searchParams.SearchAnySignUpDate"></wl-date-selector>
            </span>

            <label
              ><input type="checkbox" [(ngModel)]="searchParams.SearchAnySignUpDate" />
              {{ 'events.registration.management.search-any-date-label' | translate | titlecase }}</label
            >
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-6">
            <p>{{ 'events.registration.management.advanced-common-criteria-label' | translate | titlecase }}</p>

            <label>
              <input type="checkbox" [(ngModel)]="searchParams.AllUnpaid" />
              {{ 'events.registration.management.show-all-unpaid-label' | translate | titlecase }}
            </label>
            <br />
            <label>
              <input type="checkbox" [(ngModel)]="searchParams.AllWithBlankAttendees" />
              {{ 'events.registration.management.show-all-with-blank-attendees-label' | translate | titlecase }}
            </label>
            <br />
            <label>
              <input type="checkbox" [(ngModel)]="searchParams.AllWithProfileIdNotAssigned" />
              {{ 'events.registration.management.show-all-with-no-profile-id-assigned-label' | translate | titlecase }}
            </label>
            <br />
            <label>
              {{ 'events.registration.management.invoice-number-label' | translate | titlecase }}
              <input type="number" [(ngModel)]="searchParams.InvoiceNumber" />
            </label>

            <p>
              <button
                pButton
                type="button"
                class="atlas-btn atlas-btn-default"
                (click)="search()"
                [disabled]="isSearching"
                [icon]="isSearching ? '' : 'pi pi-search'"
                [label]="(isSearching ? 'common.searching' : 'common.search') | translate | titlecase"
              >
                <wl-busy [show]="isSearching"></wl-busy>
              </button>
            </p>
          </div>
          <div class="col-sm-6">
            <p>{{ 'events.registration.management.event-items-label' | translate | titlecase }}</p>
            <div class="event-items-container">
              @for (eventItem of eventItems; track eventItem.ItemNum) {
                <div>
                  <label>
                    <input type="checkbox" [(ngModel)]="eventItem.Selected" />
                    {{ eventItem.Descr }}
                  </label>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <div class="mb-27">
      <div class="w-100">
        <div class="input-group">
          <select class="form-control" [(ngModel)]="selectedAction" (ngModelChange)="actionChanged($event)">
            @for (action of actions; track action.value) {
              <option [value]="action.value" [selected]="action.value == selectedAction ? true : null">
                {{ action.name }}
              </option>
            }
          </select>
          <span class="input-group-btn">
            <button
              pButton
              type="button"
              class="atlas-btn atlas-btn-primary atlas-actions-btn"
              icon="pi pi-play"
              (click)="executeAction()"
            ></button>
            <wl-busy [show]="exporting"></wl-busy>
            <img src="/assets/img/help.png" title="{{ 'events.registration.management.actions-help' | translate }}" class="wc-help-icon" />
          </span>
        </div>
      </div>

      <div class="mb-27 pt-15 w-100 flex row-collapse content-end">
        <span class="mr-10">{{ 'common.view' | translate | ucfirst }}</span>
        <p-selectButton [options]="viewOptions" [(ngModel)]="displayGrid" optionLabel="icon" (click)="storeRegViewOption()">
          <ng-template let-item #item>
            <i [class]="item.icon"></i>
          </ng-template>
        </p-selectButton>
      </div>

      <div class="atlas-table" [hidden]="displayGrid.value == false">
        <p-table
          [showGridlines]="true"
          [value]="registrationSearchResult?.Result"
          [paginator]="true"
          [rows]="searchParams ? searchParams.PageSize : 20"
          [totalRecords]="registrationSearchResult?.TotalCount"
          (onLazyLoad)="lazyLoadRegistrations($event)"
          [lazy]="true"
          [loading]="isSearching"
        >
          <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
            @if (sortOrder === 0) {
              <SortAltIcon>
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
              </SortAltIcon>
            }
            @if (sortOrder === 1) {
              <SortAmountUpAltIcon [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
              </SortAmountUpAltIcon>
            }
            @if (sortOrder === -1) {
              <SortAmountDownIcon [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
              </SortAmountDownIcon>
            }
          </ng-template>
          <ng-template #header>
            <tr>
              <th pSortableColumn="SignUpDate" [style]="{ width: '105px' }">
                {{ 'events.registration.management.grid.date' | translate }}
                <p-sortIcon field="SignUpDate"></p-sortIcon>
              </th>
              <th pSortableColumn="Id" [style]="{ width: '90px' }">
                {{ 'events.registration.management.grid.id' | translate }}
                <p-sortIcon field="Id"></p-sortIcon>
              </th>
              <th pSortableColumn="DisplayName" [style]="{ width: '200px' }">
                {{ 'events.registration.management.grid.org' | translate }}
                <p-sortIcon field="DisplayName"></p-sortIcon>
              </th>
              <th pSortableColumn="LastName" [style]="{ width: '150px' }">
                {{ 'events.registration.management.grid.name' | translate }}
                <p-sortIcon field="LastName"></p-sortIcon>
              </th>
              <th [style]="{ width: '40px' }"></th>
              <th pSortableColumn="Email" [style]="{ width: '200px' }">
                {{ 'events.registration.management.grid.reg-email' | translate }}
                <p-sortIcon field="Email"></p-sortIcon>
              </th>
              <th pSortableColumn="AttendeeCount" [style]="{ width: '115px' }">
                {{ 'events.registration.management.grid.attendees' | translate }}
                <p-sortIcon field="AttendeeCount"></p-sortIcon>
              </th>
              <th pSortableColumn="ItemsDisplay">
                {{ 'events.registration.management.grid.items' | translate }}
                <p-sortIcon field="ItemsDisplay"></p-sortIcon>
              </th>
              <th pSortableColumn="AmountInvoiced" [style]="{ width: '100px' }">
                {{ 'events.registration.management.grid.total' | translate }}
                <p-sortIcon field="AmountInvoiced"></p-sortIcon>
              </th>
              <th pSortableColumn="AmountInvoiced" [style]="{ width: '100px' }">
                {{ 'events.registration.management.grid.due' | translate }}
                <p-sortIcon field="AmountInvoiced"></p-sortIcon>
              </th>
              <th [style]="{ width: '40px' }">{{ 'common.actions' | translate | ucfirst }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-registration>
            <tr>
              <td>{{ registration.SignUpDate | date: 'MM/dd/yyyy' }}</td>
              <td>
                @if (registration.ProfileID) {
                  <span>{{ registration.ProfileID }}</span>
                } @else {
                  <a (click)="openCreateProfileDialog(registration)">{{ 'events.registration.management.grid.no-profile' | translate }}</a>
                }
              </td>
              <td>{{ registration.DisplayName }}</td>
              <td>{{ registration.FirstName }}&nbsp;{{ registration.LastName }}</td>
              <td class="t-ac">
                <a (click)="editRegistration(registration)"><img src="/assets/img/edit.svg" /></a>
              </td>
              <td style="max-width: 200px" class="p-grid-column-overflow-truncate">
                <a [href]="'mailto:' + registration.Email" target="_blank">{{ registration.Email }}</a>
              </td>
              <td class="t-ac">
                <a
                  (click)="editRegistrationAttendees(registration)"
                  [pTooltip]="attendeesTooltip"
                  tooltipStyleClass="p-tooltip-wide"
                  tooltipPosition="top"
                  (mouseover)="loadAttendeeDetails(registration)"
                  >{{ registration.AttendeeHeaderCount }}</a
                >
                <ng-template #attendeesTooltip>
                  <wl-busy [show]="registration.LoadingDetails"></wl-busy>
                  <div [hidden]="registration.LoadingDetails">
                    @for (attendee of registration.Attendees; track attendee) {
                      <div>
                        <span
                          >{{ attendee.FName }}&nbsp;{{ attendee.LName }}&nbsp;({{
                            attendee.ProfileID ? attendee.ProfileID : ('events.registration.management.grid.no-profile' | translate)
                          }})</span
                        >
                      </div>
                    }
                  </div>
                </ng-template>
              </td>
              <td [innerHtml]="formatRegItems(registration)"></td>
              <td>
                <span class="t-ar">{{ registration.AmountInvoiced | currency }}</span>
              </td>
              <td>
                @if (registration.AmountInvoiced - registration.AmountPaid > 0) {
                  <span class="red-text t-ar">
                    {{ registration.AmountInvoiced - registration.AmountPaid | currency }}
                  </span>
                }
              </td>
              <td class="p-0">
                <action-button icon="pi pi-ellipsis-h" [items]="actionItemsForRegistration(registration)"> </action-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <wl-page-size-dropdown
          [(pageSize)]="searchParams.PageSize"
          [pageSizes]="[20, 100]"
          (pageSizeChange)="pageSizeChanged()"
        ></wl-page-size-dropdown>
      </div>

      <div class="flex row-collapse" [hidden]="displayGrid.value == true">
        <div class="w-100">
          <div class="event-list wc-with-cards wc-with-prime-list" [wl-busy-overlay]="isSearching">
            <div [hidden]="isSearching || registrationSearchResult.Result.length">
              {{ 'events.registration.management.no-registrations-message' | translate }}
            </div>
            <p-dataView
              #registrationsDataGrid
              [rows]="20"
              [value]="registrationSearchResult.Result"
              [totalRecords]="registrationSearchResult.TotalCount"
              layout="grid"
              [lazy]="true"
              [loading]="isSearching"
              [paginator]="true"
              paginatorPosition="bottom"
              (onLazyLoad)="lazyLoadRegistrations($event)"
            >
              <ng-template let-cols let-registrations #grid>
                @for (registration of registrations; track registration.Id) {
                  <div class="card card-override" data-cy="divRegistrationManagementCardContainer">
                    <div class="card-block">
                      <div class="wc-card-controls pull-right">
                        <input type="checkbox" [(ngModel)]="registration.Selected" />
                      </div>
                      <h4 class="card-title">
                        <wl-profile-type-icon
                          [isMember]="registration.Member"
                          [isOrg]="registration.OrgInd"
                          [profileId]="registration.ProfileID"
                          [memberTypeIconColor]="registration.MemberTypeIconColor"
                        ></wl-profile-type-icon>
                        <a href="#" (click)="$event.preventDefault(); editRegistration(registration)">
                          @if (registration.ProfileID > 0) {
                            <span
                              >{{ registration.ProfileReportName || registration.DisplayName }}&nbsp;({{ registration.ProfileID }})</span
                            >
                          } @else {
                            <span
                              >{{ registration.DisplayName }}&nbsp;({{
                                'events.registration.management.no-profile-label' | translate | titlecase
                              }})</span
                            >
                          }
                        </a>
                      </h4>
                      @if (registration.OrgInd == true) {
                        <div class="card-text">{{ registration.FirstName }}&nbsp;{{ registration.LastName }}</div>
                      }
                      <div class="card-text">
                        {{ registration.SignUpDate | date: 'MM/dd/yyyy' }}
                      </div>
                      @if (registration.Email != '') {
                        <div class="card-text">
                          <a [href]="'mailto:' + registration.Email">{{ registration.Email }}</a>
                        </div>
                      }
                      <div class="card-text">
                        {{ registration.ItemsDisplay }}
                      </div>

                      <p class="card-text">
                        <b>
                          {{ 'common.revenue.total' | translate | titlecase }}&nbsp;{{
                            registration.AmountInvoiced | currency
                          }}&nbsp;&nbsp;{{ 'common.revenue.amount-due' | translate | titlecase }}&nbsp;
                          @if (registration.AmountInvoiced - registration.AmountPaid > 0) {
                            <span class="text-danger">{{ registration.AmountInvoiced - registration.AmountPaid | currency }}</span>
                          } @else {
                            <span>{{ registration.AmountInvoiced - registration.AmountPaid | currency }}</span>
                          }
                        </b>
                      </p>

                      <p class="card-text">
                        <button
                          pButton
                          type="button"
                          class="atlas-btn btn-xs atlas-btn-default"
                          data-cy="btnRegistrationManagementShowAttendees"
                          [ngClass]="{ 'wl-event-reg-open-close-open': registration.ShowDetails }"
                          title="{{ 'common.show' | translate | titlecase }} {{ 'common.details' | translate | titlecase }}"
                          (click)="toggleDetails(registration)"
                        >
                          <span class="wl-event-reg-open-close-icon glyphicon glyphicon-chevron-down"></span>
                        </button>
                        {{ 'events.registration.management.registration-attendees-header-label' | translate | titlecase }}
                        <span [hidden]="!registration.UnkownAttendeesCount">
                          ({{ registration.UnkownAttendeesCount }} {{ 'events.registration.management.unknown-out-of' | translate }}
                          {{ registration.PotentialAttendeeCount }})
                        </span>
                        <wl-busy [show]="registration.LoadingDetails"></wl-busy>
                      </p>
                    </div>

                    @if (registration.ShowDetails) {
                      <ul class="list-group list-group-flush">
                        @for (attendee of registration.Attendees; track attendee) {
                          <li class="list-group-item">
                            {{ attendee.FName }}&nbsp;{{ attendee.LName }}&nbsp;(
                            @if (attendee.ProfileID > 0) {
                              <span>{{ attendee.ProfileID }}</span>
                            } @else {
                              <span>{{ 'events.registration.management.no-profile-label' | translate | titlecase }}</span>
                            }
                            )
                          </li>
                        }
                      </ul>
                    }

                    <div class="mb-20 mh-20 mct-flex mct-row mct-justify-between mct-items-center">
                      <div>
                        <button
                          pButton
                          type="button"
                          class="atlas-btn atlas-btn-default mr-10"
                          data-cy="btnRegistrationManagementEdit"
                          [disabled]="launchedModal"
                          (click)="editRegistration(registration)"
                          title="{{ 'common.edit' | translate | titlecase }} ({{ registration.Id }})"
                        >
                          {{ 'common.edit' | translate | uppercase }}
                        </button>
                        <button
                          pButton
                          type="button"
                          class="atlas-btn atlas-btn-default mr-10"
                          data-cy="btnRegistrationManagementViewInvoice"
                          title="{{ 'events.registration.management.invoice-number' | translate | titlecase }}{{ registration.InvoiceNum }}"
                          (click)="viewInvoice(registration)"
                          [hidden]="registration.InvoiceNum == 0"
                        >
                          {{ 'events.registration.management.view-invoice' | translate | uppercase }}
                        </button>
                        <button
                          pButton
                          type="button"
                          *wlAccessControl="editInvoiceAccessControl"
                          type="button"
                          class="atlas-btn atlas-btn-default"
                          data-cy="btnRegistrationManagementEditInvoice"
                          (click)="goToInvoiceEdit(registration)"
                          [hidden]="registration.InvoiceNum == 0"
                          title="{{ 'events.registration.management.edit-invoice' | translate | titlecase }}"
                        >
                          {{ 'events.registration.management.edit-invoice' | translate | uppercase }}
                        </button>
                      </div>
                      <span [wl-busy-overlay]="registration._loadingConfirmationMessage" [busyCenter]="true"> </span>
                      <div>
                        <p-menu #menu [model]="registration._menuItems" [popup]="true" appendTo="body" />
                        <button
                          pButton
                          type="button"
                          (click)="menu.toggle($event)"
                          icon="pi pi-ellipsis-h"
                          class="atlas-btn atlas-btn-default"
                        ></button>
                      </div>
                    </div>
                  </div>
                }
              </ng-template>
            </p-dataView>
          </div>
        </div>
      </div>
    </div>

    <app-back-to-top></app-back-to-top>
  </div>

  <wl-event-v4-registration-delete
    #deleteDialog
    (onDialogResult)="registrationDeleteDialogHandler($event)"
  ></wl-event-v4-registration-delete>
  <wl-event-v4-registration-management-selector
    #registrationSelector
    (confirmed)="handleRegistrationSelectorOkClick($event)"
  ></wl-event-v4-registration-management-selector>

  <div>
    <div>
      <wl-event-v4-registration-wizard
        #registrationWizardModal
        (onRegistrationSaved)="handleRegistrationSaved($event)"
        (onRegistrationClose)="handleRegistrationClosed()"
      ></wl-event-v4-registration-wizard>
    </div>
  </div>
  <wl-event-v4-create-registration-profile-dialog
    (modalClosed)="getRegistrations()"
    (modalClosedAndEditRegistration)="editRegistration($event)"
  >
  </wl-event-v4-create-registration-profile-dialog>
</div>
